import { parse, stringifyUrl } from 'query-string';
import { useCallback, useMemo } from 'react';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
/**
 * ソート切り替えに応じてURL書き換えを行うuse
 * @param args
 */
export const useSelectSort = (args) => {
    const { defaultSort = undefined, options, path, search } = args;
    const history = useNavigate();
    /**
     * クエリ
     */
    const query = useMemo(() => parse(search), [search]);
    const { sort: querySort } = query;
    /**
     *  ソート値
     */
    const sort = useMemo(() => {
        const queryOption = options.find((v) => v.value === querySort);
        const defaultOption = options.find((v) => v.value === defaultSort);
        return (queryOption === null || queryOption === void 0 ? void 0 : queryOption.value) || (defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.value);
    }, [defaultSort, querySort, options]);
    /**
     * セレクトボックス切り替え時のURL書き換えイベント
     */
    const onChangeSort = useCallback((value) => {
        const url = stringifyUrl({ query: Object.assign(Object.assign({}, query), { sort: value }), url: path });
        history.push(url);
    }, [history, query, path]);
    return {
        onChangeSort,
        sort,
    };
};
